// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"new-cars-offers_pageWrapper__FpUBX"};